import { Box, Table, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import UPButton from 'components/button';

export const StyledTableCell = styled(TableCell)({
  [`&.${tableCellClasses.head}`]: {
    fontWeight: 'bold',
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
});

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const AdminDashboardTitle = styled(Typography)(({ theme }) => ({
  fontSize: '24px',
  display: 'flex',
  color: theme.palette.primary.main,
  fontWeight: 'regular',
  alignItems: 'flex-end',
  marginLeft: '4px',
}));

export const SearchInputContainer = styled(Box)(() => ({
  width: '300px',
  alignContent: 'center',
}));

export const DashboardFilterButton = styled(UPButton)(({ theme }) => ({
  height: '48px',
  [theme.breakpoints.down(690)]: {
    margin: '6px',
  },
}));

export const HeaderContainer = styled(Box)(({ theme }) => ({
  marginBottom: '16px',
  display: 'flex',
  [theme.breakpoints.down(815)]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
  },
}));

export const TilesRow = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '16px',
  marginBottom: '24px',
}));

export const TitleWithWeekContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  gap: '32px',
}));

export const SearchWithFilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  flex: 1,
  gap: '16px',
  marginLeft: '16px',
  [theme.breakpoints.down(815)]: {
    marginLeft: '5px',
    alignItems: 'center',
  },
}));

export const TableExpansionContainer = styled(Box)(() => ({
  width: '100%',
  overflowX: 'auto',
  maxWidth: '100%',
  margin: '1px',
}));

export const DetailsTable = styled(Table)(() => ({
  width: '100%',
  tableLayout: 'fixed',
  wordBreak: 'break-word',
  size: 'small',
}));
